/**
 * Created by sivanh on 09/01/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");

    var EMPTY_IP = "...";
    var IP_VERSION = {
        "IPV4":"IPv4",
        "IPV6":"IPv6"
    };


    var ApiKeyIpRangeItemModel = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        ApiKeyIpRangeItemModel = BaseModel.extend({
            defaults:{
                from:EMPTY_IP,
                to:EMPTY_IP,
                ipVersion:IP_VERSION.IPV4
            },
            initialize: function() {
              this.errors = {withinListDuplicated: false};
            },

            getFromIp: function(){
                return this.get("from");
            },
            getToIp: function(){
                return this.get("to");
            },

            getPartOfIp:function (type, index) {
                return this.get(type).split(".")[index];
            },

            setPartOfIp:function (type, index, value) {
                if (!this._validatePartOfIp(type, index, value)) {
                    var splittedIp = this.get(type).split(".");
                    splittedIp[index] = value;
                    var newValue = splittedIp.join(".");
                    this.set(type, newValue);
                    return this;
                }
                else {
                    return false;
                }

            },

            isIpEmpty:function (type) {
                return this.get(type) === EMPTY_IP;
            },

            _validatePartOfIp:function (type, index, valStr) {
                var invalid = true;

                // A should never be 0.
                var minValue = (index === 0 ? 1 : 0);

                if (valStr.length > 0) {
                    // Allow only 3-digit numbers without leading zeros, or the number 0
                    if (valStr.match(/^([1-9]\d{0,2}|[0])$/) != null) {
                        var val = parseInt(valStr, 10);

                        if (val >= minValue && val <= 255) {
                            invalid = false;
                        }
                    }
                }
                else {
                    invalid = false;
                }

                return invalid;
            },

            validation:{
                "from":[
                    {
                        fn:function () {
                            if (this.isIpEmpty("from")) {
                                return "LEManager.manager.dataSources.Api_Keys.item.ip.restriction.errors.ipRange.from.required";
                            }
                        }
                    },
                    {
                        pattern:"IPv4",
                        msg:"LEManager.manager.dataSources.Api_Keys.item.ip.restriction.errors.ipRange.from.invalid"
                    },
                    {
                        fn:function () {
                            if (this.errors.withinListDuplicated) {
                                return "LEManager.manager.dataSources.Api_Keys.item.ip.restriction.errors.ipRange.duplicate.ranges";
                            }
                        }
                    },

                ],
                "to":[
                    {
                        fn:function () {
                            if (this.isIpEmpty("to")) {
                                return "LEManager.manager.dataSources.Api_Keys.item.ip.restriction.errors.ipRange.to.required";
                            }
                        }
                    },
                    {
                        pattern:"IPv4",
                        msg:"LEManager.manager.dataSources.Api_Keys.item.ip.restriction.errors.ipRange.to.invalid"
                    },
                    {
                        fn:function () {
                            if (!this._isRangeValid()) {
                                return "LEManager.manager.dataSources.Api_Keys.item.ip.restriction.errors.ipRange.to.range";
                            }
                        }
                    },
                    {
                        fn:function () {
                            if (this.errors.withinListDuplicated) {
                                return "LEManager.manager.dataSources.Api_Keys.item.ip.restriction.errors.ipRange.duplicate.ranges";
                            }
                        }
                    },
                ]
            },

            _isRangeValid:function () {
                var fromAsNumber = this._getIpAsNumber("from");
                var toAsNumber = this._getIpAsNumber("to");

                return (toAsNumber - fromAsNumber >= 0);
            },

            _getIpAsNumber:function (type) {
                var splittedIp = this.get(type).split(".");
                var ipAsNumber = (16777216 * parseInt(splittedIp[0], 10)) + (65536 * parseInt(splittedIp[1], 10)) + (256 * parseInt(splittedIp[2], 10)) + parseInt(splittedIp[3], 10);

                return ipAsNumber;
            }

        });

    });
    return ApiKeyIpRangeItemModel;
});
